import { FC } from 'react';
import { Provider } from 'react-redux';
import { Store } from 'redux';
import { useLazyLoadQuery, graphql } from 'react-relay';
import { Locale } from 'dibs-intl/exports/locales';
import { DEVICE_TYPES } from 'dibs-buyer-layout/exports/deviceTypeEnums';
import { IntlProvider } from 'dibs-react-intl';
import { DibsWeb3ReactProvider } from 'dibs-crypto-utils/exports/DibsWeb3ReactProvider';

import { CREATORS } from '../nftHeader/pageType';
import { NftHeaderLayout } from '../nftHeader/NftHeaderLayout';
import { NftCreatorsLayout } from './NftCreatorsLayout';
import {
    NftCreatorsWrapperQuery,
    NftCreatorsWrapperQuery$variables,
} from './__generated__/NftCreatorsWrapperQuery.graphql';

type Props = {
    locale: Locale;
    deviceType: DEVICE_TYPES;
    store: Store;
    variables: NftCreatorsWrapperQuery$variables;
};

export const NftCreatorsWrapper: FC<Props> = ({ locale, store, variables, deviceType }) => {
    const data = useLazyLoadQuery<NftCreatorsWrapperQuery>(
        graphql`
            query NftCreatorsWrapperQuery($pageId: String = "", $creatorsItemCount: Int = 80) {
                viewer {
                    ...NftCreatorsLayout_viewer
                    ...NftHeaderLayout_viewer
                }
            }
        `,
        variables
    );
    return (
        <IntlProvider locale={locale} disableTranslations>
            <DibsWeb3ReactProvider>
                <Provider store={store}>
                    <NftHeaderLayout
                        viewer={data.viewer}
                        isNftLandingPage
                        serverDeviceType={deviceType}
                        initialPageType={CREATORS}
                    >
                        <NftCreatorsLayout viewer={data.viewer} />
                    </NftHeaderLayout>
                </Provider>
            </DibsWeb3ReactProvider>
        </IntlProvider>
    );
};
